import { useEffect } from "react";

const RadioButton = ({
    label,
    field,
    isRequired = true,
    catalog,
    value = '',
    onChange
}: IPropsRadioButton) => {

    const IsChekedValue = (valueRadio: string) => (valueRadio === value);
    const ChangeCbo = (event: any) =>  onChange(event.target.name, event.target.value);   
     
    return (
        <>
            <div className='mt-10 mb-5 lbl-input-radio-re-ni'>
                {label}
            </div>
            <div>
                {catalog?.map((x: ICatalog, index: number) => {
                    return (
                        <div key={`radio_${field}_${x.value}`} className='radio-re-ni'>
                            <input key={`id_${field}_${x.value}`} id={`id_${field}_${index}`} type='radio' name={field} value={x.value} checked={IsChekedValue(x.value)} onChange={ChangeCbo} required={isRequired} />
                            <label key={`lbl_${field}_${x.value}`} className='lbl-input-radio-re-ni2' htmlFor={`id_${field}_${index}`}>{x.text}</label>
                        </div>
                    )
                })}
            </div>
        </>
    )
}

export { RadioButton };